<template>
    <div class="jd-evaluate-form">
        <k-cell>
<!--            <span class="cl-desc">综合评分：</span>-->
            <div  class="ta-center">
                <k-rate
                        v-model="star"
                        color="#CEA065"
                        void-icon="star"
                        void-color="#eee"
                        size="0.5rem"
                        style="display: inline-block; vertical-align: middle;"
                />
            </div>

        </k-cell>
        <k-cell>
            <span class="cl-desc">服务态度：</span>
            <k-button :type="service===1?'primary':'default'" round size="mini" @click="select('service', 1)">非常满意</k-button>
            <k-button :type="service===2?'primary':'default'" round size="mini" @click="select('service', 2)">满意</k-button>
            <k-button :type="service===3?'primary':'default'" round size="mini" @click="select('service', 3)">一般</k-button>
            <k-button :type="service===4?'primary':'default'" round size="mini" @click="select('service', 4)">不满意</k-button>
        </k-cell>
        <k-cell>
            <span class="cl-desc">鉴定速度：</span>
            <k-button :type="speed===1?'primary':'default'" round size="mini" @click="select('speed', 1)">非常满意</k-button>
            <k-button :type="speed===2?'primary':'default'" round size="mini" @click="select('speed', 2)">满意</k-button>
            <k-button :type="speed===3?'primary':'default'" round size="mini" @click="select('speed', 3)">一般</k-button>
            <k-button :type="speed===4?'primary':'default'" round size="mini" @click="select('speed', 4)">不满意</k-button>
        </k-cell>
        <k-cell>
            <k-button type="primary" block @click="submitForm" :disabled="!isOk">提交评价</k-button>
        </k-cell>
    </div>
</template>

<script>
    import {mapActions} from "vuex"
    export default {
        name: "evaluate-form",
        props: ["orderId"],
        data() {
            return {
                star : 0,
                service : 1,
                speed : 1,
                isOk : false
            }
        },
        methods : {
            ...mapActions("jianding", ["goEvaluate"]),
            select(type, val){
                if(type && val){
                    this[type] = val
                }
            },
            async submitForm(){
                let {orderId, star, service, speed} = this;
                await this.goEvaluate({orderId, star, service, speed}).then(R => {
                    this.$toast.success('提交成功');
                    location.reload();
                    this.$emit("success",{});
                }).catch(err => {
                    this.$toast.fail(err.message);
                })

                //location.reload();
            },
            ckData(){
                let {star, service, speed, isOk} = this;
                if(star && service && speed){
                    this.isOk = true;
                    return true;
                }
                this.isOk = false;
                return false;
            },
        },
        watch : {
            star(nv){
                this.ckData()
            }
        }
    }
</script>

<style scoped>

</style>